import { handleErrorException, loading, error, success } from 'State/actions';
import { ReportGeneration } from 'Common/ObjectHelper';
import { AdjustmentEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getAdjustmentListData = filtersOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ADJUSTMENT_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Adjustment/GetAdjustments',
        filtersOptions
      );
      dispatch(success(types.ADJUSTMENT_LIST_DATA, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Adjustment. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.ADJUSTMENT_LIST_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.ADJUSTMENT_LIST_LOADING, false));
    }
  };
};

export const getPrintAdjustmentData = printRequestData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_PREVIEW_ADJUSTMENT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Adjustment/GetAdjustmentsPrint',
        printRequestData
      );
      const data = response.data.Data[AdjustmentEnum.ReportResultString];
      if (data) {
        ReportGeneration(data, 'Adjustment Report');
      }
      if (response.data.Data.Message) {
        dispatch(error(types.PRINT_PREVIEW_ERROR, response));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while Printing Adjustment List. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.PRINT_PREVIEW_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.PRINT_PREVIEW_ADJUSTMENT_LOADING, false));
    }
  };
};

export const clearAdjustmentGridData = () => {
  return {
    type: types.ADJUSTMENT_CLEAR_GRID_DATA,
  };
};

export const clearAdjustmentGridError = () => {
  return {
    type: types.CLEAR_ADJUSTMENT_LIST_ERROR,
  };
};
export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/adjustmentList/actions.js